import React, {useEffect} from 'react';
import MainPage from 'containers/pages/MainPage';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {BrowserRouter as Router} from 'react-router-dom';
import Modal from 'components/modals/Modals';
import store from 'redux/configureStore';
import EntityContextProvider from 'contexts/EntityContext';
import SavedSearchContextProvider from 'contexts/SavedSearchContext';
import ErrorContextProvider from 'contexts/ErrorContext';
import ErrorBoundary from 'components/ErrorBoundary';
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

export default function App() {
    toast.configure({
        autoClose: 3000,
        position: toast.POSITION.TOP_CENTER,
    });

    useEffect(() => {
        //do not sure if it's working
        window.addEventListener('storage', (e) => {
            // When local storage changes, checks if state variable is changed and if so updates redux auth
            if(e.key === 'state' && e.newValue !== null) {
                //console.log(`New Value: ${JSON.parse(e.newValue).auth.wsseToken.accessToken}`);
                //console.log('New Value: ', e.newValue);
                //console.log('Old Value: ', e.oldValue);
                if(JSON.parse(e.newValue).auth.isAuthenticated) {
                    if(e.newValue !== e.oldValue) {
                        console.log(JSON.parse(e.newValue).auth);
                        store.dispatch({type: 'auth/SET_AUTH', data: JSON.parse(e.newValue).auth});
                        //window.localStorage.setItem('state', e.newValue);
                    }
                } else {
                    store.dispatch({type: 'auth/LOG_OUT'});
                }
            }
        });
    }, []);

    return (
        <Router history={history}>
            <ErrorContextProvider>
                <EntityContextProvider>
                    <SavedSearchContextProvider>
                        <ErrorBoundary>
                            <>
                                <Modal/>
                                <MainPage/>
                            </>
                        </ErrorBoundary>
                    </SavedSearchContextProvider>
                </EntityContextProvider>
            </ErrorContextProvider>
        </Router>
    );
}
